import { WorkPlaces } from "../types/place";

export const places: WorkPlaces[] = [
  {
    id: 1,
    title: "Punky Geek Consulting",
    subTitle: "Web Developer",
    date: "March 2017 - June 2020",
    initials: "PG",
    description: "Developed and maintained WordPress and non-WordPress websites, implemented content updates, troubleshot frontend issues, and performed site QA.",
  },
  {
    id: 2,
    title: "SolutionBuilt",
    subTitle: "Frontend WordPress Developer",
    date: "March 2022 - April 2024",
    initials: "SB",
    description: "Developed responsive WordPress websites using Astra, ACF, HTML, CSS, and JavaScript.",
  },
  {
    id: 3,
    title: "Craft & Communicate",
    subTitle: "Web Developer",
    date: "June 2024 - Present",
    initials: "CC",
    description: "Maintained and updated established websites and assisted with the build process for new sites using Elementor.",
  },
];